var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpArrows = function SvgUpArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.46 237.905v48.959h-30.431v-48.959h-74.355v132.146h179.139V237.905zM358.337 99.01v31.776h-30.431V99.01h-63.928v108.465h158.286V99.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428.243 400.482H207.965a74.6 74.6 0 0 0-19.721-21.965 73.7 73.7 0 0 0-28.887-13.029V59.981L99.376 0 77.859 21.517l51.068 51.068v292.904c-33.554 7.036-58.831 36.852-58.831 72.466 0 40.828 33.217 74.045 74.046 74.045 27.161 0 50.938-14.71 63.823-36.572h233.939v-74.946zm-284.102 62.844c-14.012 0-25.372-11.36-25.372-25.372s11.36-25.372 25.372-25.372 25.372 11.36 25.372 25.372c-.001 14.013-11.36 25.372-25.372 25.372"
  })));
};
export default SvgUpArrows;